var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    fill: "#21BB8E",
    stroke: "#484C4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42969 7.7422V18.2267C5.42969 18.5742 5.55315 18.9076 5.77292 19.1534C5.99269 19.3991 6.29076 19.5372 6.60156 19.5372H18.3203C18.4757 19.5372 18.6247 19.4682 18.7346 19.3453C18.8445 19.2224 18.9062 19.0557 18.9062 18.8819V9.70804C18.9062 9.53425 18.8445 9.36757 18.7346 9.24468C18.6247 9.1218 18.4757 9.05276 18.3203 9.05276H6.60156C6.29076 9.05276 5.99269 8.91468 5.77292 8.6689C5.55315 8.42313 5.42969 8.08978 5.42969 7.7422ZM5.42969 7.7422C5.42969 7.39462 5.55315 7.06127 5.77292 6.81549C5.99269 6.56972 6.29076 6.43164 6.60156 6.43164H16.5625",
    stroke: "#484C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6836 15.278C16.169 15.278 16.5625 14.8379 16.5625 14.2951C16.5625 13.7522 16.169 13.3121 15.6836 13.3121C15.1982 13.3121 14.8047 13.7522 14.8047 14.2951C14.8047 14.8379 15.1982 15.278 15.6836 15.278Z",
    fill: "#484C4E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletCircle);
export default __webpack_public_path__ + "static/media/wallet-circle.2ffeff0c.svg";
export { ForwardRef as ReactComponent };